import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function CheckboxIndeterminate(props: Props) {
  const colorValue = props.fill ?? (props.sx as any)?.color ?? '#01ADEF';
  return (
    <SvgIcon {...props} sx={{ ...props.sx, color: colorValue }}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" fill="currentColor" />
        <path d="M13.3302 10.0007H6.66357" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
}
